import './App.css';
import './UserHeader.css';

import axios from 'axios';
import { useEffect, useState } from 'react';

function UserHeader({
    user_id,
    onClick,
}) {
    const [user, setUser] = useState(null);

    function loadUser(user_id) {
        axios.get(
            process.env.REACT_APP_API_HOST + `/users/${user_id}/`,
            {},
        ).then(
            (response) => {
                setUser(response.data);
            }
        )
    }

    useEffect(
        () => {
            if (user_id == 'me') {
                loadUser(localStorage.getItem('user_id'));
                return;
            }

            loadUser(user_id);
        },
        []
    );

    if (!user) {
        return null;
    }

    return (
        <div
            className='user-header'
            onClick={onClick}
        >
            <div className='user-default-image'>
                {user.full_name[0]}
            </div>
            <div className='user-header-full-name'>
                <b>
                    {user.full_name}
                </b>
            </div>
        </div>
    );
}

export default UserHeader;